import { ePartyPurpose } from '../../enums/ePartyPurpose';
import { IPartyPerson, IPartyPersonData } from './IPartyPerson';
import { IPartyEntity } from './IPartyEntity';
import { IPartyEntityData } from './IPartyEntityData';
import { ePartyTypeData } from '../../enums/ePartyTypeData';
import { ePartyType } from '../../enums/ePartyType';

export type IParty = IPartyEntity | IPartyPerson;

export const FullName = (party?: IParty): string => {
  if (party?.type === ePartyType.person) {
    return FullNameOfPerson(party);
  } else {
    return party?.entity_name || '';
  }
};
export const FullNameOfPerson = (party: Partial<Pick<IPartyPerson, 'first_name' | 'last_name' | 'middle_name'>>) =>
  `${party.first_name}${party.middle_name ? ` ${party.middle_name}` : ``} ${party.last_name}`;

export type IPartyData = IPartyEntityData | IPartyPersonData;

export const FullNamePartyData = (party: IPartyData) => {
  if (party.partyType === ePartyTypeData.Person) {
    return FullNameOfPersonData(party);
  } else {
    return party.name;
  }
};
export const FullNameOfPersonData = (party: Partial<Pick<IPartyPersonData, 'firstName' | 'middleName' | 'lastName'>>) =>
  `${party.firstName}${party.middleName ? ` ${party.middleName}` : ``} ${party.lastName}`;

export function assertIsEntity(entity: IParty): asserts entity is IPartyEntity {
  if (entity.type !== ePartyType.entity) {
    throw Error('Party was not an entity as was expected');
  }
}

const setOfBuyerBorrowers = new Set([ePartyPurpose.buyer, ePartyPurpose.borrower]);
export const isBuyerBorrower = (party: IParty | IPartyData) => setOfBuyerBorrowers.has(party.purpose);
